import { Button, Col, Form, Row } from 'antd';
import { MasterSubCategory } from 'domain/entities/MasterEntity';
import { UserInfo } from 'domain/entities/UserEntity';
import { AppProps } from 'presentation/App';
import { openErrorNoti } from 'presentation/components/Notification';
import { FormInput } from 'presentation/components/form/FormInput.component';
import { FormRadio } from 'presentation/components/form/FormRadio.component';
import { FormSelect } from 'presentation/components/form/FormSelect.component';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { MASTER_CATEGORY_LIST } from 'utilities/constants/COMMON';
import { MEMBER_TYPE_PERSONAL } from '../../CU-003-01';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';

const MASTER_GROUP_CODES = [
    MASTER_CATEGORY_LIST.USER_AGE_CLASSIFICATION,
    MASTER_CATEGORY_LIST.MARITAL_STATUS_CLASSIFICATION,
    MASTER_CATEGORY_LIST.OCCUPATION_CATEGORY_CLASSIFICATION,
    MASTER_CATEGORY_LIST.ANNUAL_INCONME_RANGE_CLASSIFICATION,
    MASTER_CATEGORY_LIST.HOUSE_TYPE_CLASSIFICATION,
    MASTER_CATEGORY_LIST.HOUSING_LOAN_EXISTS_CLASSIFICATION,
    MASTER_CATEGORY_LIST.INVESMENT_PROPERTY_EXISTS_CLASSIFICATION,
];

const FormRegisInfomantion = (props: AppProps) => {
    const [form] = Form.useForm();
    const [btnDisable, setBtnDisable] = React.useState<boolean>(true);
    const [requireOccupationOthers, setRequireOccupationOthers] = useState<boolean>(false);
    const [requireHouseOthers, setRequireHouseOthers] = useState<boolean>(false);
    const [masterData, setMasterData] = useState<any>();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { masterUseCase, userUseCase } = props;

    useEffect(() => {
        form.setFieldsValue({
            age: null,
            maritalStatus: null,
            childrenCount: null,
            livingWithFamilyCount: null,
            occupationCategory: null,
            occutationOthers: null,
            annualIncomeRange: null,
            houseType: null,
            houseOthers: null,
            housingLoanExists: null,
            invesmentPropertyExist: null,
        });
        initiateOptions();
    }, []);

    const initiateOptions = async () => {
        try {
            dispatch(startFetching());
            const options = await masterUseCase.getMasterSubCategoryGroupList({
                categoryCodes: MASTER_GROUP_CODES,
            });
            const masterDataInit: any = {
                ...options,
            };
            masterDataInit[MASTER_CATEGORY_LIST.USER_AGE_CLASSIFICATION] = options[
                MASTER_CATEGORY_LIST.USER_AGE_CLASSIFICATION
            ]?.map((item: MasterSubCategory) => {
                return {
                    label: item.codeName,
                    value: item.code,
                };
            });
            masterDataInit[MASTER_CATEGORY_LIST.MARITAL_STATUS_CLASSIFICATION] = options[
                MASTER_CATEGORY_LIST.MARITAL_STATUS_CLASSIFICATION
            ]?.map((item: MasterSubCategory) => {
                return {
                    label: item.codeName,
                    value: item.code,
                };
            });
            masterDataInit[MASTER_CATEGORY_LIST.OCCUPATION_CATEGORY_CLASSIFICATION] = options[
                MASTER_CATEGORY_LIST.OCCUPATION_CATEGORY_CLASSIFICATION
            ]?.map((item: MasterSubCategory) => {
                return {
                    label: item.codeName,
                    value: item.code,
                };
            });
            masterDataInit[MASTER_CATEGORY_LIST.ANNUAL_INCONME_RANGE_CLASSIFICATION] = options[
                MASTER_CATEGORY_LIST.ANNUAL_INCONME_RANGE_CLASSIFICATION
            ]?.map((item: MasterSubCategory) => {
                return {
                    label: item.codeName,
                    value: item.code,
                };
            });
            masterDataInit[MASTER_CATEGORY_LIST.HOUSE_TYPE_CLASSIFICATION] = options[
                MASTER_CATEGORY_LIST.HOUSE_TYPE_CLASSIFICATION
            ]?.map((item: MasterSubCategory) => {
                return {
                    label: item.codeName,
                    value: item.code,
                };
            });
            masterDataInit[MASTER_CATEGORY_LIST.HOUSING_LOAN_EXISTS_CLASSIFICATION] = options[
                MASTER_CATEGORY_LIST.HOUSING_LOAN_EXISTS_CLASSIFICATION
            ]?.map((item: MasterSubCategory) => {
                return {
                    label: item.codeName,
                    value: item.code,
                };
            });
            masterDataInit[MASTER_CATEGORY_LIST.INVESMENT_PROPERTY_EXISTS_CLASSIFICATION] = options[
                MASTER_CATEGORY_LIST.INVESMENT_PROPERTY_EXISTS_CLASSIFICATION
            ]?.map((item: MasterSubCategory) => {
                return {
                    label: item.codeName,
                    value: item.code,
                };
            });
            setMasterData(masterDataInit);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const changeBtnDisable = (isError: any) => {
        if (isError) {
            setBtnDisable(true);
        } else {
            onChangeForm();
        }
    }

    const onChangeForm = () => {
        form.validateFields({
            validateOnly: true,
        })
            .then(() => {
                setBtnDisable(false);
            })
            .catch((err) => {
                setBtnDisable(err.errorFields.length > 0);
            });
    };

    const onSubmit = async (values: any) => {
        try {
            dispatch(startFetching());
            const userInfo: UserInfo = {
                ...values,
                memberType: MEMBER_TYPE_PERSONAL,
            };
            const response = await userUseCase.registUserInfo(userInfo);
            if (response) {
                navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_003_02}`);
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    return (
        <div className="w-full">
            <Form form={form} onValuesChange={onChangeForm} onFinish={onSubmit} className="w-full">
                <Row gutter={[24, 0]}>
                    <Col span={12}>
                        <FormSelect
                            options={masterData?.[MASTER_CATEGORY_LIST.USER_AGE_CLASSIFICATION]}
                            label="年代"
                            required
                            name="age"
                            size={'large'}
                            labelClassName="content-step-form label-step-form"
                        />
                    </Col>
                    <Col span={12}>
                        <FormInput
                            suffix={'人'}
                            required
                            type="number"
                            maxLength={2}
                            label="同居家族の人数"
                            size={'large'}
                            name="livingWithFamilyCount"
                            labelClassName="content-step-form label-step-form"
                            placeholder={PLACEHOLDER.LIVING_FAMILY_COUNT}
                        />
                    </Col>
                </Row>
                <Row gutter={[24, 0]}>
                    <Col span={12}>
                        <FormSelect
                            options={
                                masterData?.[MASTER_CATEGORY_LIST.MARITAL_STATUS_CLASSIFICATION]
                            }
                            label="現在の婚姻ステータス"
                            required
                            name="maritalStatus"
                            size={'large'}
                            labelClassName="content-step-form label-step-form"
                        />
                    </Col>
                    <Col span={12}>
                        <FormInput
                            suffix={'人'}
                            required
                            type="number"
                            maxLength={2}
                            label="子供の人数"
                            size={'large'}
                            name="childrenCount"
                            labelClassName="content-step-form label-step-form"
                            placeholder={PLACEHOLDER.LIVING_CHILDREN_COUNT}
                        />
                    </Col>
                </Row>
                <Row gutter={[24, 0]}>
                    <Col span={12}>
                        <FormSelect
                            options={
                                masterData?.[
                                    MASTER_CATEGORY_LIST.OCCUPATION_CATEGORY_CLASSIFICATION
                                ]
                            }
                            label="職業"
                            required
                            name="occupationCategory"
                            size={'large'}
                            labelClassName="content-step-form label-step-form"
                            onChange={(e) => {
                                setRequireOccupationOthers(e == '99')
                            }}
                        />
                    </Col>
                    <Col span={12}>
                        <FormInput
                            required={requireOccupationOthers}
                            disabled={!requireOccupationOthers}
                            maxLength={20}
                            label="職業その他"
                            size={'large'}
                            name="occupationOthers"
                            labelClassName="content-step-form label-step-form"
                            currentForm={form}
                            onValidateError={changeBtnDisable}
                        />
                    </Col>
                </Row>
                <Row gutter={[24, 0]}>
                    <Col span={12}>
                        <FormSelect
                            options={
                                masterData?.[
                                    MASTER_CATEGORY_LIST.ANNUAL_INCONME_RANGE_CLASSIFICATION
                                ]
                            }
                            label="年収"
                            required
                            name="annualIncomeRange"
                            size={'large'}
                            labelClassName="content-step-form label-step-form"
                        />
                    </Col>
                    <Col span={12}>
                        <FormSelect
                            options={masterData?.[MASTER_CATEGORY_LIST.HOUSE_TYPE_CLASSIFICATION]}
                            label="居住環境"
                            required
                            name="houseType"
                            size={'large'}
                            labelClassName="content-step-form label-step-form"
                            onChange={(e) => {
                                setRequireHouseOthers(e == '99')
                            }}
                        />
                    </Col>
                </Row>
                <Row gutter={[24, 0]}>
                    <Col span={12}>
                        <FormInput
                            required={requireHouseOthers}
                            disabled={!requireHouseOthers}
                            maxLength={20}
                            label="居住環境その他"
                            size={'large'}
                            name="houseOthers"
                            labelClassName="content-step-form label-step-form"
                            currentForm={form}
                            onValidateError={changeBtnDisable}
                        />
                    </Col>
                </Row>
                <Row gutter={[24, 0]}>
                    <Col span={12}>
                        <FormRadio
                            options={
                                masterData?.[
                                    MASTER_CATEGORY_LIST.HOUSING_LOAN_EXISTS_CLASSIFICATION
                                ]
                            }
                            name="housingLoanExists"
                            label="ローン有無"
                            required
                        />
                    </Col>

                    <Col span={12}>
                        <FormRadio
                            options={
                                masterData?.[
                                    MASTER_CATEGORY_LIST.INVESMENT_PROPERTY_EXISTS_CLASSIFICATION
                                ]
                            }
                            name="investmentPropertyExists"
                            label="投資用不動産所有有無"
                            required
                        />
                    </Col>
                </Row>

                <Row gutter={[24, 0]} className="justify-center">
                    <Col span={12}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{ width: '100%', height: 56, marginTop: 16 }}
                            disabled={btnDisable}
                        >
                            この内容で登録する
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};
export default FormRegisInfomantion;
